import jsPDF from "jspdf";
import moment from "moment";
import "./Amiri-Regular-normal";
import "./Amiri-Bold-bold";
import logoOs from "../../assets/logo.png";
import momenthijri from "moment-hijri";
import { DaysInArabic } from "../../dummy/dummy";

const addPDFHeader = (doc) => {
  var logo = new Image();
  logo.src = logoOs;

  doc.addImage(logo, "png", 170, 8, 35, 15);

  doc.setFont("Amiri-Regular");
  doc.setFontSize(14);
  doc.text("بسم الله الرحمن الرحيم", 105, 30, null, null, "center");
  doc.setFontSize(11);
};

export const exportContractToPdf = (data) => {
  const d = new Date();
  let day = DaysInArabic[d.getDay()];
  var doc = new jsPDF("p", "mm", "a4");
  doc.setFont("Amiri-Regular");
  addPDFHeader(doc);
  doc.setFontSize(14);
  doc.text("عقد وساطة للتمويل بالعمولة", 105, 50, {
    align: "center",
    lang: "ar",
  });
  doc.text(
    185,
    70,
    `بعون الله تعالى، ففي يوم ${day} ، بتاريخ ${momenthijri().format(
      "YYYY/M/D"
    )} ه الموافق${moment().format("YYYY/MM/DD")} م تم `,
    { align: "right", lang: "ar" }
  );
  //doc.text(180, 75,{align: 'right',lang: 'ar'});
  doc.text(185, 80, ":الاتفاق بين كل من", { align: "right", lang: "ar" });
  doc.text(185, 90, "-1 ", { align: "right", lang: "ar" });
  doc.text(
    175,
    90,
    `:شركة الأصول العربية العقارية، سجل تجاري رقم: ${")1010901605("}، هاتف رقم`,
    { align: "right", lang: "ar" }
  );
  doc.text(175, 100, "(920020310)", { align: "right", lang: "ar" });
  doc.text(147, 100, "،", { align: "right", lang: "ar" });
  doc.text(
    144,
    100,
    "ويمثلها في العقد والتوقيع؛ السيد/ بكر بن محمد بن أبكر إسحاق",
    { align: "right", lang: "ar" }
  );
  doc.text(
    175,
    110,
    ".سعودي الجنسية هوية وطنية رقم )1107582577(، عنوانه: الرياض",
    { align: "right", lang: "ar" }
  );
  doc.text(175, 120, ".ويشار إليها فيما بعد بالطرف الأول", {
    align: "right",
    lang: "ar",
  });
  doc.text(185, 130, "-2 ", { align: "right", lang: "ar" });
  doc.text(175, 130, `السيد/ ${data.Customer.AspNetUsers.FullName}`, {
    align: "right",
    lang: "ar",
  });
  doc.text(110, 130, `سعودي الجنسية، هوية وطنية رقم`, {
    align: "right",
    lang: "ar",
  });
  doc.text(175, 140, `(${data.Customer.NationalIdentityNumber})`, {
    align: "right",
    lang: "ar",
  });
  doc.text(120, 140, `:عنوانه                         ,جوال رقم`, {
    align: "right",
    lang: "ar",
  });
  doc.text(
    175,
    150,
    data.Customer.AspNetUsers.PhoneKey +
      data?.Customer.AspNetUsers?.PhoneNumber,
    { align: "right", lang: "ar" }
  );
  doc.text(185, 163, "التمهيد", { align: "right", lang: "ar" });
  doc.text(
    170,
    171,
    "وحيث أن الطرف الأول يمتهن مهنة الوساطة التمويلية وذلك عن طريق أحد البنوك، أو",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    178,
    "إحدى جهات التمويل، وفق أحكام وقواعد الشريعة الإسلامية وأنظمة المملكة العربية",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    185,
    "السعودية، وحيث أن الطرف الثاني يرغب بشراء عقار عن طريق إحدى الجهات",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    192,
    "التمويلية، ويرغب بإسناد مهمة البحث عن التمويل المناسب له للطرف الأول، وعليه",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    199,
    "فقد التقت إرادة الطرفين على أن يقوم الطرف الأول بالبحث عن التمويل وفق",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    206,
    "الاشتراطات المنصوص عليها في هذا العقد، وذلك مقابل عمولة يدفعها الطرف الثاني",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    213,
    "للطرف الأول، لذا فقد اتفق الطرفان وهما بكامل الأهلية المعتبرة شرعًا لإبرام هذا",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 220, ".العقد", { align: "right", lang: "ar" });
  doc.text(185, 227, ":أولاً", { align: "right", lang: "ar" });
  doc.text(
    170,
    234,
    ".يعتبر التمهيد المذكور أعلاه جزء لا يتجزأ من هذا العقد ويقرأ ويفسر معه",
    { align: "right", lang: "ar" }
  );
  doc.text(185, 244, ":ثانياً: ملحق الاتفاق", { align: "right", lang: "ar" });
  doc.text(
    170,
    251,
    "إذا تعارضت بنود هذا العقد مع أي بند مكتوب في أي ملحق من ملاحق هذا العقد؛ ",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 258, "فيقدم المتأخر منهما.", { align: "right", lang: "ar" });
  //////
  doc.addPage("p", "mm", "a4");
  doc.text(185, 50, ":ثالثاً: السرية", { align: "right", lang: "ar" });
  doc.text(
    170,
    57,
    "يلتزم الطرف الأول بالحفاظ على السرية التامة لبيانات عملائه وعدم إفشاء أي معلومات",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    64,
    "عنهم أو عن معاملاتهم إلى الغير بدون موافقاتهم الكتابية المسبقة، وفي حدود هذه",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    71,
    ".الموافقة، باستثناء الحالات التي يلزم فيها تقديم معلومات محددة للجهات المختصة",
    { align: "right", lang: "ar" }
  );
  doc.text(185, 81, ":رابعاً: التزامات الطرف الأول", {
    align: "right",
    lang: "ar",
  });
  doc.text(180, 88, "-1 ", { align: "right", lang: "ar" });
  doc.text(
    170,
    88,
    "يقوم الطرف الأول بمفاوضة البنك أو الجهة التمويلية، والاتفاق معه على تمويل",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    95,
    "الطرف الثاني وإجراء ما يلزم لأخذ موافقة البنك أو إحدى الجهات التمويلية على إتمام",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 102, ".تمويل البنك أو الجهة التمويلية لصالح الطرف الثاني", {
    align: "right",
    lang: "ar",
  });
  doc.text(180, 109, "-2 ", { align: "right", lang: "ar" });
  doc.text(
    170,
    109,
    "يلتزم الطرف الأول تجاه الطرف الثاني بأن يبذل كافة مساعيه وجهوده والخبرة",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    116,
    ".المتوافرة لديه من أجل إيجاد التمويل المناسب للطرف الثاني حسب حالته الائتمانية",
    { align: "right", lang: "ar" }
  );
  doc.text(185, 126, ":خامساً: التزامات الطرف الثاني", {
    align: "right",
    lang: "ar",
  });
  doc.text(180, 133, "-1 ", { align: "right", lang: "ar" });
  doc.text(
    170,
    133,
    `يدفع الطرف الثاني للطرف الأول عمولة وقدرها )${data.Profit}( مقابل قيام الطرف الأول بالوفاء`,
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    140,
    "بالتزاماته المذكورة في هذا العقد، ويتم دفع هذه العمولة مقدماً، ويحرر الطرف الأول",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 147, ".سند استلام رسمي لصالح الطرف الثاني", {
    align: "right",
    lang: "ar",
  });
  doc.text(180, 154, "-2 ", { align: "right", lang: "ar" });
  doc.text(
    170,
    154,
    "يدفع الطرف الثاني للطرف الأول ضريبة القيمة المضافة بنسبة قدرها )15%( من",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    161,
    ". (1)إجمالي عمولة الطرف الأول المذكور نسبتها في البند الخامس في الفقرة",
    { align: "right", lang: "ar" }
  );
  doc.text(180, 168, "-3 ", { align: "right", lang: "ar" });
  doc.text(
    170,
    168,
    `.يحرر الطرف الثاني سند لأمر بقيمة وقدرها )   ${
      data.RealestateFinancingRequest?.SupportInstallment ||
      data.PersonalFinancingRequest?.SupportInstallment ||
      0
    }  (  ريال سعودي`,
    { align: "right", lang: "ar" }
  );
  doc.text(185, 178, ":سادساً: انسحاب الطرفين", { align: "right", lang: "ar" });
  doc.text(180, 185, "-1 ", { align: "right", lang: "ar" });
  doc.text(
    170,
    185,
    "في حالة رجوع الطرف الثاني عن إبرام العقد لسبب يعود له وليس للطرف الأول علاقة",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    192,
    "،به، فإن العمولة التي دفعها الطرف الثاني للطرف الأول تكون من حق الطرف الأول ",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 198, ".وذلك لقيام الطرف الأول بالوفاء بكافة التزاماته", {
    align: "right",
    lang: "ar",
  });
  doc.text(180, 205, "-2 ", { align: "right", lang: "ar" });
  doc.text(
    170,
    205,
    "في حالة عدم إتمام البيع لسبب لا يعود للطرف الثاني، مثل رجوع مالك العقار",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    212,
    "عن البيع، أو ظهور عيوب في العقار، أو أي سبب آخر ليس للطرف الثاني علاقة ",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    219,
    "،به، فإنه في هذه الحالة يعيد الطرف الأول للطرف الثاني العمولة التي دفعها فورًا",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    226,
    "على أن يدفع الطرف الثاني للطرف الأول رسوم إدارية مقدارها 1.000 ألف ريال ",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 233, ".سعودي مقابل الأعمال الإدارية التي قامت بها الشركة", {
    align: "right",
    lang: "ar",
  });
  //////
  doc.addPage("p", "mm", "a4");
  doc.text(185, 50, ":سابعاً: انتهاء العلاقة", { align: "right", lang: "ar" });
  doc.text(
    170,
    57,
    "بعد موافقة البنك، أو الجهة التمويلية على إتمام التمويل وتوقيع العقد معهم، فإن مهمة",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    64,
    "الطرف الأول قد انتهت ويحكم العلاقة التي بينهما (الطرف الثاني – الجهة الممولة)",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 71, ".العقد المبرم بينهما", { align: "right", lang: "ar" });
  doc.text(185, 81, ":ثامناً: العناوين", { align: "right", lang: "ar" });
  doc.text(
    170,
    88,
    "يقر الطرفان بأن العناوين المذكورة في هذا العقد هي العناوين المعتمدة للمراسلات",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    95,
    "والإخطار بين الطرفين، ويلتزم كل من الطرف الأول والطرف الثاني بإشعار الآخر في حالة",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    102,
    "تغييره بإشعاره كتابة (بتوقيع الطرفين أو بالإشعار عبر البريد الالكتروني) وإلا اعتبرت ",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    109,
    "جميع الإعلانات والمراسلات التي تمت على هذا العنوان صحيحة ومنتجة لآثارها",
    { align: "right", lang: "ar" }
  );
  doc.text(170, 116, ".القانونية", { align: "right", lang: "ar" });
  doc.text(185, 126, ":تاسعاً: إقرارات الطرفين", {
    align: "right",
    lang: "ar",
  });
  doc.text(
    170,
    133,
    "يقر الطرفان بأنهما اطلعا على جميع بنود هذا العقد الاطلاع التام النافي للجهالة كما يقر",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    140,
    "الطرفان أنهما قبلا التوقيع على هذه البنود وحيث أن إرادة أطراف هذا العقد قد تلاقتا",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    147,
    ".إيجابا وقبولا وهما بكامل أهليتهما المعتبرة شرعا على إبرام هذا العقد",
    { align: "right", lang: "ar" }
  );
  doc.text(185, 157, ":عاشراً: حدوث النزاع", { align: "right", lang: "ar" });
  doc.text(
    170,
    164,
    "في حال حدوث نزاع أو خلاف بين الطرفين فيحل بالطرق الودية خلال خمسة عشر",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    171,
    ".يوماً، وفي حالة تعذر حله ودياً في حال النزاع إلى المحكمة المختصة بمدينة الرياض",
    { align: "right", lang: "ar" }
  );
  doc.text(185, 181, ":الحادي عشر: نسخ العقد", { align: "right", lang: "ar" });
  doc.text(
    170,
    188,
    "حرر هذا العقد من نسختين أصليتين بيد كل طرف نسخة للعمل بموجبها، وقد تفاهم",
    { align: "right", lang: "ar" }
  );
  doc.text(
    170,
    195,
    ".الطرفان على الوفاء بالعقد وحسن المعاملة وإعطاء كل ذي حق حقه",
    { align: "right", lang: "ar" }
  );
  doc.text(105, 210, "...والله الموفق", { align: "center", lang: "ar" });
  doc.text(160, 225, "الطرف الأول", { align: "right", lang: "ar" });
  doc.text(80, 225, "الطرف الثاني", { align: "right", lang: "ar" });
  doc.text(170, 235, "الاسم: شركة الأصول العربية", {
    align: "right",
    lang: "ar",
  });
  doc.text(170, 245, ":التوقيع", { align: "right", lang: "ar" });
  doc.text(90, 235, `الاسم: ${data.Customer.AspNetUsers.FullName}`, {
    align: "right",
    lang: "ar",
  });
  doc.text(90, 245, ":التوقيع", { align: "right", lang: "ar" });

  doc.save(`OsoolContract-${moment().format("YYYY/MM/DD HH:mm:ss")}.pdf`);
};
